import AlertError from './AlertError';

export const apiError = error => {
  throw new AlertError(
    error.response ? error.response.statusText
      : window.app.$t(window.app.$lang.app.COULD_NOT_CONNECT_SERVER),
  );
};
